import { each } from 'lodash'

export class Sheet {
  grade: number = 0
  name: string = ""
  curriculum_id: number = 0
  subject_name: string = ""
  subject_code: string
  sheet_type: number
  exec_date: string

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.sheet_type = sheet.sheet_type;
    this.exec_date = sheet.exec_date;
  }
}

export class Examinee {
  id: number
  sheet_id: number
  room_name: string
  student_no: number
  student_no_character: string
  student_name: string
  score: string
  total_rank: string
  room_rank: string

  constructor(examinee: any, examinees: any[]){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.room_name = examinee.room_name;
    this.student_no = examinee.student_no;
    this.student_no_character = examinee.student_no_character == null ? "-" : examinee.student_no_character;
    this.student_name = examinee.student_name == null ? "-" : examinee.student_name;
    this.score = `${examinee.score}点`;
    this.total_rank = `${examinee.total_rank}位/${examinees.length}人`;
    this.room_rank = `${examinee.room_rank}位/${examinees.filter((x: any) => x.room_name == examinee.room_name).length}人`;
  }
}